import React, { useCallback, useEffect } from 'react';
import qs from 'qs';

import { useLocation } from '@reach/router';
import { Configure, InstantSearch } from 'react-instantsearch-dom';
import { connectSearchBox } from 'react-instantsearch-dom';

import './Header.scss';
import { IconArrowUpRightTeal, IconHamburgher, IconHeaderCloud, IconLogo } from '../Icons';
import { MOBILE_OPEN } from '../../utils/constants';
import useWindowSize from '../../hooks/useWindowSize';
import SearchBar from '../SearchBar/SearchBar';
import { searchClient } from '../../hooks/useAlgolia';
import { getSearchBarActualPage } from '../../utils/functions';

const VirtualSearchBox = connectSearchBox(() => null);

export default function Header(): React.ReactElement {
  const location = useLocation();
  const { isDesktop, width } = useWindowSize();
  const isBrowser = typeof window !== 'undefined';
  const [searchState, setSearchState] = React.useState(() => urlToSearchState(isBrowser ? window.location : { search: '' }));
  const actualPage = getSearchBarActualPage(location.pathname.split('/'));

  useEffect(() => {
    localStorage.setItem(MOBILE_OPEN, null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Add query string to URL
  function createURL(searchState) {
    return qs.stringify({ query: searchState.query }, { addQueryPrefix: true });
  }

  function urlToSearchState({ search }) {
    return qs.parse(search.slice(1));
  }

  const onSubmit = useCallback(({ state }) => {
    setSearchState((searchState) => ({
      ...searchState,
      isOpen: true,
      collections: state.collections,
      query: state.query,
    }));

    //Working
    // const servicesValue = _.debounce(() => {
    //   console.log('2');
    //   setSearchState((searchState) => ({
    //     ...searchState,
    //     isOpen: true,
    //     collections: state.collections,
    //     query: state.query,
    //   }));
    // }, 1000);

    // servicesValue();
  }, []);

  const onReset = useCallback(() => {
    setSearchState((searchState) => ({
      ...searchState,
      query: '',
    }));
  }, []);
  //console.log('searchState', searchState); // Researched Query
  return (
    <header className="header">
      <a tabIndex={1} className="header__logo header__nav" href={process.env.GATSBY_DOCS_URL}>
        <IconLogo />
      </a>
      <InstantSearch
        indexName={process.env.GATSBY_ALGOLIA_INDEX_NAME}
        searchClient={searchClient}
        searchState={searchState}
        onSearchStateChange={setSearchState}
        createURL={createURL}
      >
        {/* With no filter, all tutorials will be returned */}
        {/* <Configure filters="documentation_type:'Tutorials'" /> */}
        <Configure filters="environment:'docs.arduino.cc'" />
        <VirtualSearchBox />
        <SearchBar onReset={onReset} onSubmit={onSubmit} searchState={searchState} actualPage={actualPage} />
      </InstantSearch>
      {(isDesktop || !width) && (
        <div className="header__right">
          <a className="header__nav" tabIndex={3} href={process.env.GATSBY_CLOUD_URL}>
            <IconHeaderCloud />
          </a>
          <a className="header__arduino-cc header__nav" tabIndex={3} href={process.env.GATSBY_ARDUINO_URL}>
            <span>ARDUINO.CC</span> <IconArrowUpRightTeal />
          </a>
        </div>
      )}
      {!isDesktop && width && (
        <button
          className="header__navigation"
          onClick={() => {
            localStorage.setItem(MOBILE_OPEN, localStorage.getItem(MOBILE_OPEN) === 'opened' ? 'closed' : 'opened');
          }}
        >
          <IconHamburgher />
        </button>
      )}
    </header>
  );
}
